import { LocationNumbersService } from "../../../services"

const purchaseNumberWithStripe = async ({ dispatch, state }, config) => {
  const { locationId, payload } = config

  let paymentMethodId = payload?.paymentMethodId ?? state?.customerPayment?.invoiceSettings?.defaultPaymentMethod?.id ?? state?.customerPayment?.defaultSource?.id

  try {
    if(!paymentMethodId) {
      const  customerPaymentMethod = await LocationNumbersService.getCustomerPayment(locationId)
      paymentMethodId = customerPaymentMethod?.invoiceSettings?.defaultPaymentMethod?.id ?? customerPaymentMethod?.defaultSource?.id
    }

    const data = await LocationNumbersService.setPurchaseNumberWithStripe(
      locationId,
      {
        ...payload,
        paymentMethodId
      }
    )

    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchPhoneNumbers', {
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      }
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default purchaseNumberWithStripe
